import diacritics from 'diacritics'
import Fuse from 'fuse.js'

import { Client } from './client.interface'

/**
 * Creates an index to look for clients
 * @param clients
 */
export function createClientsIndex(clients: Client[]) {
  return new Fuse(clients, {
    keys: ['name', 'email', 'phone', 'taxName', 'taxNumber'],
    threshold: 0.25,
    getFn(object: any, path: string | string[]) {
      path = Array.isArray(path) ? path[0] : path
      const value = object[path]
      if (!value) {
        return ''
      }

      return diacritics.remove(object[path])
    },
  })
}
